class Menu {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    $(function() {
      $('.hamburger').click(function() {
          $(this).toggleClass('active');
   
          if ($(this).hasClass('active')) {
              $('.globalMenu').addClass('active');
              $('.l-header__logo').addClass('active');
          } else {
              $('.globalMenu').removeClass('active');
              $('.l-header__logo').removeClass('active');
          }
      });
  });
  }
}
